<template>
  <div v-if="error">
    <b-alert
        show
        class="mt-3"
        variant="danger"
        dismissible
    >
      <div v-if="error.errors">
        <template v-for="(value) in error.errors">
          <span v-for="(error, index) in value" :key="index">
            {{ error }}
          </span>
        </template>
      </div>
      <div v-else>
        <span v-if="error.message">
        {{ error.message }}
        </span>
        <span v-else>
          {{ $t('common.error') }}
        </span>
      </div>
    </b-alert>
  </div>
</template>

<script>
export default {
  name: "ValidationError",
  props: ['error'],
  data() {
    return {
      data: {
        errors: {
          email: ["The selected email is invalid."]
        }
      }
    }
  }
}
</script>

<style scoped>

</style>